/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * Publication readership band used for pricing.
 */
export type PublicationAudience = typeof PublicationAudience[keyof typeof PublicationAudience];


export const PublicationAudience = {
  general: 'general',
  child: 'child',
} as const;
